export default __webpack_public_path__ + "static/media/markets.f76986a4.svg";